type UserAccessInfoCardProps = {
  currentUserRole: { id: number; name: string } | null;
  roles: { id: number; name: string }[];
  handleDropdownChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  roleError?: string;
  createUser?: boolean;
};
export const UserAccessInfoCard = ({
  currentUserRole,
  roles,
  handleDropdownChange,
  roleError,
  createUser,
}: UserAccessInfoCardProps) => {
  const isContact = currentUserRole?.id === 3;

  // remove the contact role from the dropdown if the user is not a contact
  // we also remove the other roles if the user is a contact.
  // note that the role still exists in the original roles list
  const getAvailableRoles = () => {
    if (createUser) {
      return roles;
    }
    if (!isContact) {
      return roles.filter((role) => role.id !== 3);
    } else if (isContact) {
      return roles.filter((role) => role.id === 3);
    }
    return roles;
  };

  return (
    <div>
      <h3 className="mt-10 mb-5 label-light-blue-xl">
        権限 <span className="text-red-500">*</span>
      </h3>
      <div className="mb-2 text-xl text-black">
        <select
          className={
            isContact && !createUser
              ? "dropdown-bar-disabled bg-zinc-200 cursor-not-allowed"
              : "dropdown-bar"
          }
          value={currentUserRole?.id || ""}
          onChange={handleDropdownChange}
          disabled={isContact && !createUser}
        >
          <option value="">未選択</option>
          {getAvailableRoles()?.map((role) => (
            <option key={role.id} value={role.id}>
              {role.name}
            </option>
          ))}
        </select>
        {roleError && <p className="text-red-500 mt-2">{roleError}</p>}
        {isContact && !createUser && (
          <p className="text-black text-sm mt-2">
            連絡先の権限は変更できません。
          </p>
        )}
      </div>
    </div>
  );
};
